import { useLocation, useMount } from 'react-use';
import { useState } from 'react';

export const useSearchAlertInfo = () => {
  const location = useLocation();

  const [shouldShowSearchAlertInfo, setShouldShowSearchAlertInfo] = useState(false);

  useMount(() => {
    const query = new URLSearchParams(location.search);
    const hasSearchAlertInfoParam = query.get('ns-search-alert-info') === 'true';

    if (hasSearchAlertInfoParam) {
      if (!window['cmp-script']) {
        setShouldShowSearchAlertInfo(true);
        return;
      }

      window.didomiOnReady = window.didomiOnReady || [];
      window.didomiOnReady.push(() => {
        // If cookie consent dialog is open, wait for it to close before showing the SA info dialog.
        if (document.body.classList.contains('didomi-popup-open')) {
          window.Didomi?.on('notice.hidden', () => setShouldShowSearchAlertInfo(true));
        } else {
          setShouldShowSearchAlertInfo(true);
        }
      });
    }
  });

  return [shouldShowSearchAlertInfo, setShouldShowSearchAlertInfo] as const;
};
